import React, { Fragment, useState, useEffect } from "react";
import { useFormik } from "formik";
import PropTypes from "prop-types";
import TextField from "@material-ui/core/TextField";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";

import * as Yup from "yup";

import Button from "../../components/button";

const SendInstantSwitchNotificationForm = props => {

    const formik = useFormik({
        initialValues: {
            message: ""
        },
        validationSchema: Yup.object({
            message: Yup.string()
                .required("Please enter the message")
                .min(2, "Message must be of atleat 10 characters")
        }),
        onSubmit: values => {
            props.onFormSubmit(values.message);
        }
    });

    const [preFilledValues, setPreFilledValues] = React.useState({});


    const handleChange = event => {
        const filledValue = preFilledValues[event.target.value]
            ? preFilledValues[event.target.value]
            : "";
        formik.values.message = filledValue;
        formik.setFieldValue("message", filledValue);
    };

    useEffect(() => {
        if (props.isInstantHush) {
            setPreFilledValues({
                "Follow-Up":
                    `Hi ${props.patientName}. \n\nAn Instant Hush doctor has been attempting to contact you from a private number to review your online assessment and assist you with a ${props.assessmentType} Treatment Plan. If you were unavailable at the time the doctor called, please email us a new date and time you would prefer to be contacted. If you no longer require a treatment plan, please email us and we will cease following you up. Thank you. \n\nInstant Hush Support\nsupport@instanthush.com.au`,
                "Deleted":
                    `Hi ${props.patientName}. \n\nAn Instant Hush doctor has been attempting to contact you from a private number to review your online assessment and assist you with a ${props.assessmentType} Treatment Plan. They have been unable to get in touch with you after multiple attempts. Your online assessment will be deleted. If you still require a treatment plan, please start a new online assessment. Thank you. \n\nInstant Hush Support \nsupport@instanthush.com.au`,
            });
        } else {
            setPreFilledValues({
                "Smoking-Cessation-Follow-Up":
                    `Hi ${props.patientName}. \n\nAn Instant Switch doctor has been attempting to contact you from a private number to review your online assessment and assist you with a Smoking Cessation Treatment Plan. If you were unavailable at the time the doctor called, please email us a new date and time you would prefer to be contacted. If you no longer require a treatment plan, please email us and we will cease following you up. Thank you.`,
                "Smoking-Cessation-Deleted":
                    `Hi ${props.patientName}. \n\nAn Instant Switch doctor has been attempting to contact you from a private number to review your online assessment and assist you with a Smoking Cessation Treatment Plan. They have been unable to get in touch with you after multiple attempts. Your online assessment will be deleted. If you still require a treatment plan, please start a new online assessment. Thank you.`,
                "Smoking-Cessation-Medicare-Invalid":
                    `Hi ${props.patientName}. \n\nThank you for signing up to Instant Switch. We noticed you may have had trouble validating your Medicare card details when submitting your online assessment. We have since verified your Medicare information and you are now eligible for a BULK-BILLED consult with an Instant Switch doctor. \n\nIf you still need to speak to a doctor about a smoking cessation treatment plan, please log into https://patient.instantswitch.com.au/ and submit your draft assessment. It will no longer ask you for private payment.`,
                "Medicinal-Cannabis-Follow-Up": `Hi ${props.patientName}. \n\nAn Instant Switch doctor has been attempting to contact you from a private number to review your online assessment and assist you with a Medicinal Plant Therapy Treatment Plan. If you were unavailable at the time the doctor called, please email us a new date and time you would prefer to be contacted. If you no longer require a treatment plan, please email us and we will cease following you up. Thank you.`,
                "Medicinal-Cannabis-Deleted":
                    `Hi ${props.patientName}. \n\nAn Instant Switch doctor has been attempting to contact you from a private number to review your online assessment and assist you with a Medicinal Plant Therapy Treatment Plan. They have been unable to get in touch with you after multiple attempts. Your online assessment will be deleted. If you still require a treatment plan, please start a new online assessment. Thank you.`,
                "Medicinal-Cannabis-Medicare-Invalid":
                    `Hi ${props.patientName}. \n\nThank you for signing up to Instant Switch. We noticed you may have had trouble validating your Medicare card details when submitting your online assessment. We have since verified your Medicare information and you are now eligible for electronic prescribing, when clinically appropriate, with an Instant Switch doctor. \n\nIf you still need to speak to a doctor about a medicinal plant therapy treatment plan, please log into https://patient.instantswitch.com.au/ and submit your draft assessment.`,
            });
        }
    }, []);


    return (
        <Fragment>
            <p>
                Message <span className="error">*</span>
            </p>
            <RadioGroup
                row
                aria-label="notificationSelection"
                name="notificationSelection"
                onChange={handleChange}
            >
                <FormControlLabel
                    className="col-sm-4 p-0 m-0"
                    value="Smoking-Cessation-Follow-Up"
                    control={<Radio color="primary" />}
                    label="Smoking Cessation Follow-Up"
                />
                <FormControlLabel
                    className="col-sm-4 p-0 m-0"
                    value="Smoking-Cessation-Deleted"
                    control={<Radio color="primary" />}
                    label="Smoking Cessation Deleted"
                />
                <FormControlLabel
                    className="col-sm-4 p-0 m-0"
                    value="Smoking-Cessation-Medicare-Invalid"
                    control={<Radio color="primary" />}
                    label="Smoking Cessation Medicare Invalid"
                />
                <div className="w-100 mt-3"></div>
                <FormControlLabel
                    className="col-sm-4 p-0 m-0"
                    value="Medicinal-Cannabis-Follow-Up"
                    control={<Radio color="primary" />}
                    label="Medicinal Cannabis Follow-Up"
                />
                <FormControlLabel
                    className="col-sm-4 p-0 m-0"
                    value="Medicinal-Cannabis-Deleted"
                    control={<Radio color="primary" />}
                    label="Medicinal Cannabis Deleted"
                />
                <FormControlLabel
                    className="col-sm-4 p-0 m-0"
                    value="Medicinal-Cannabis-Medicare-Invalid"
                    control={<Radio color="primary" />}
                    label="Medicinal Cannabis Medicare Invalid"
                />
            </RadioGroup>

            <form className="d-flex flex-column" onSubmit={formik.handleSubmit}>
                <TextField
                    name="message"
                    className="w-100"
                    rows={'10'}
                    multiline
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.message}
                    error={formik.touched.message && formik.errors.message ? true : false}
                    helperText={
                        formik.touched.message && formik.errors.message
                            ? formik.errors.message
                            : ""
                    }
                />
                <br />
                <p className="mb-0 d-flex justify-content-center">
                    <Button title="Submit" type="submit" />
                </p>
            </form>
        </Fragment>
    );
};

export default SendInstantSwitchNotificationForm;

SendInstantSwitchNotificationForm.propTypes = {
    onFormSubmit: PropTypes.func.isRequired,
    patientName: PropTypes.string.isRequired,
};
